import type { PublicClientApplication } from "@azure/msal-browser";
import { InteractionStatus } from "@azure/msal-browser";
import { apiScopes } from "~auth/config";
import { TokenUnavailableError } from "~auth/TokenUnavailableError.ts";
import { fetchToken } from "~auth/useAccessToken";
import { OpenAPI } from "~generated";

export function initOpenApi(msalInstance: PublicClientApplication) {
  OpenAPI.TOKEN = async () => {
    // logged out: public calls (e.g. business config on the login page) must not trigger a login redirect
    if (
      !msalInstance.getActiveAccount() &&
      msalInstance.getAllAccounts().length === 0
    ) {
      return "";
    }
    const token = await fetchToken(
      msalInstance,
      apiScopes(),
      InteractionStatus.None,
    );
    if (!token) {
      // fetchToken has started a login redirect; failing here keeps the request retryable
      throw new TokenUnavailableError();
    }
    return token;
  };
}
